import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { dbSelectorSchema } from '../../lib/db-selector';
import { SqlService } from '../../service';

export type ZoneRedundantConfig = typeof ZoneRedundantConfig._.Config;

export const ZoneRedundantConfig = IntegrationConfig.make({
  service: SqlService,
  name: Integration_Handler_Names_Enum.ZoneRedundant,
  configSchema: z.object({
    dbSelectors: z.array(dbSelectorSchema).min(1),
  }),
});
